export enum AssignmentStatus {
  Active = 1,
  Inactive = 2,
}

export interface IAssignmentUser {
  id: number
  firstName: string
  lastName: string
}

export interface IAssignmentTeam {
  id: number
  name: string
  operationalSite: { id: number; name: string } | null
}

export interface IOperationalAssignment {
  id: number
  user: IAssignmentUser | null
  operationalTeam: IAssignmentTeam | null
  startDate: string
  endDate: string | null
  reason: string
  status: AssignmentStatus
  creationUser: IAssignmentUser | null
  createdAt: string
}

export interface IGetAssignmentsParams {
  page: number
  limit: number
  q?: string
  siteIds?: string
  userIds?: string
  teamIds?: string
  from?: string
  to?: string
}

export interface IAssignmentsState {
  data: IOperationalAssignment[]
  totalCount: number
  totalPages: number
  isLoading: boolean
}
